{
  "helpMessage": "<h3>He pātai āu?</h3>\n<p>Kei konei mātou hei āwhina - waea mai:<br/><a><strong>☎️ {{phone}}</strong></a> (katahi ka pēhi i te <strong>Option 2</strong>)<br/>Rāhina ki te Rāmere, 8am–5pm.</p>",
  "title": "Kāore te pōhiri i te whaimana"
}
